import { ArrowRightLeft, Bell, FolderGit2, KeyRound, LayoutDashboard, ListChecks, Rocket, ScrollText, Server, Settings, type LucideIcon } from 'lucide-react';

export interface NavItem {
  to: string;
  label: string;
  /** Label in the mobile tab bar. */
  short?: string;
  icon: LucideIcon;
  /** Only an exact match marks it current. */
  end?: boolean;
  /** Second half of the "g <key>" keyboard shortcut. */
  key: string;
  /** Shown in the mobile tab bar (the rest live in the drawer). */
  tab?: boolean;
}

export const NAV: { heading: string; items: NavItem[] }[] = [
  {
    heading: 'Workspace',
    items: [
      { to: '/', label: 'Overview', icon: LayoutDashboard, end: true, key: 'o', tab: true },
      { to: '/projects', label: 'Projects', icon: FolderGit2, key: 'p', tab: true },
      { to: '/deployments', label: 'Deployments', short: 'Deploys', icon: Rocket, key: 'd', tab: true },
      { to: '/jobs', label: 'Jobs', icon: ListChecks, key: 'j' },
    ],
  },
  {
    heading: 'Infrastructure',
    items: [
      { to: '/vps', label: 'VPS', icon: Server, key: 'v', tab: true },
      { to: '/migrations', label: 'Migrations', icon: ArrowRightLeft, key: 'm' },
      { to: '/shared', label: 'Shared values', icon: KeyRound, key: 'k' },
    ],
  },
  {
    heading: 'Governance',
    items: [
      { to: '/notifications', label: 'Notifications', short: 'Inbox', icon: Bell, key: 'n' },
      { to: '/audit', label: 'Audit', icon: ScrollText, key: 'a' },
      { to: '/settings', label: 'Settings', icon: Settings, key: ',' },
    ],
  },
];

export const ALL_NAV: NavItem[] = NAV.flatMap((g) => g.items);

/** The nav item a pathname belongs to (the longest matching prefix). */
export function navFor(pathname: string): NavItem | undefined {
  // A deployment target is one row of the Deployments section.
  const path = pathname.startsWith('/targets/') ? '/deployments' : pathname;
  return ALL_NAV.filter((n) => (n.end ? path === n.to : path === n.to || path.startsWith(`${n.to}/`))).sort((a, b) => b.to.length - a.to.length)[0];
}

export const isMac = typeof navigator !== 'undefined' && /Mac|iPhone|iPad/.test(navigator.userAgent);
